// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3ZOgG","box":"WorkspacesBox_box__3xp54","node":"WorkspacesBox_node__2WIk1"};